export default {"src":"/_next/static/media/icon_bank_logos.4eabd57a.svg","height":45,"width":248,"blurWidth":0,"blurHeight":0};